<app-online-store-form-wrapper
  data-testid="online-store-edit-container"
  #formWrapper
  [config]="config"
  [editMode]="true"
  [viewMode]="false"
></app-online-store-form-wrapper>
